//import logo from './logo.svg';
import './App.css';
//import './Header.css';
import Header from "./Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import NavElement from './NavElement';
import HomeSlider from './HomeSlider';
import HomeForm from './HomeForm';
import FaqAndManual from './FaqAndManual';
import HomePricing from './HomePricing';
import NewsEvents from './NewsEvents';
import DownloadLEIL from './DownloadLEIL';
import Footer from './Footer';
import HomeConactus from './HomeContactus';




function App() {
  return (
  //   <div className="App">
  //   <header className="App-header">
  //     <img src={logo} className="App-logo" alt="logo" />
  //     <p>
  //       Edit <code>src/App.js</code> and save to reload.
  //     </p>
  //     <a
  //       className="App-link"
  //       href="https://reactjs.org"
  //       target="_blank"
  //       rel="noopener noreferrer"
  //     >
  //       Learn React
  //     </a>
  //   </header>
  // </div>
  <div className="App">
    <Header />
    <NavElement />
    <HomeSlider />
    <HomeForm />
    <FaqAndManual />
    <HomePricing />
    <NewsEvents />
    <DownloadLEIL />
    <HomeConactus />
    <Footer />
  </div>
  
  
  
  );
}

export default App;
